import { Component, OnInit } from '@angular/core';
import { ResponsiveService } from './_services/responsive.service';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { MessageService } from 'src/app/message/message.service';
import { syncLegacySupportWidgets } from '../legacy-support-widgets';
import { filter } from 'rxjs/operators';
@Component({
	selector: 'app-root',
	templateUrl: './gt.component.html',
	styleUrls: ['./gt.component.css'],
})
export class AppComponent implements OnInit {
	constructor(
		public responsiveService: ResponsiveService,
		private MessageService: MessageService,
		private router: Router
	) {}

	ngOnInit() {
		this.router.events.subscribe((event) => {
			if (event instanceof NavigationStart) {
				this.MessageService.clearMessages();
			}
		});
		this.router.events
			.pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
			.subscribe((event) => syncLegacySupportWidgets(event.urlAfterRedirects));
		// Set dynamic copyright year
		const year = new Date().getFullYear();
		let style = document.getElementById('dynamic-copyright-year') as HTMLStyleElement;
		if (!style) {
			style = document.createElement('style');
			style.id = 'dynamic-copyright-year';
			document.head.appendChild(style);
		}
		style.textContent = `@media print { body::after { content: "© ${year} The Learning Bar Inc. All Rights Reserved." !important; } }`;
	}
}
